// extracted by mini-css-extract-plugin
export var pageHeroFull = "ContentfulBlockFullScreenHero-module--pageHeroFull--iDh5O";
export var contentBlock = "ContentfulBlockFullScreenHero-module--contentBlock--q5JgW";
export var ctaWrap = "ContentfulBlockFullScreenHero-module--ctaWrap--ooNZ-";
export var centerscreen = "ContentfulBlockFullScreenHero-module--centerscreen--9UlWi";
export var videoContain = "ContentfulBlockFullScreenHero-module--videoContain--+oQq4";
export var bottomofscreen = "ContentfulBlockFullScreenHero-module--bottomofscreen---heUT";
export var contentWrap = "ContentfulBlockFullScreenHero-module--contentWrap--OKylR";